var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 2.8,
    fill: "#00FFC2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_1483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9448 19.5L23.5433 12.9344C23.2946 12.6793 22.9566 12.5357 22.6047 12.5357H17.4961L23.9326 19.1372C24.1589 19.3694 24.4661 19.5 24.786 19.5H29.9441H29.9448Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9454 26.4643L23.5439 19.8987C23.2946 19.643 22.9572 19.5 22.6047 19.5H17.4961L24.2863 26.4643H29.9448H29.9454Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7419 12.5357H11.8379V26.4643H16.7419V12.5357Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_1483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1071,
    height: 13.9286,
    fill: "white",
    transform: "translate(11.8379 12.5357)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.984447ece9ad843f201fde6241fc9e88.svg";
export { ForwardRef as ReactComponent };